import React, { useMemo } from 'react';
import { GraphQLList, ListPageLayout, LoadingParams, useListContext } from 'framework/list';
import {
  STAFFING_PRIORIRY_ZONES_ALIASES,
  HealthZone,
  StaffingDataType,
  StaffingRiskByPriority,
} from 'domain/shared/staffing';
import { DashboardProvider } from 'framework/ui/dashboard';
import { staffingDataGetters } from '../../dashboard/utils/staffingDataGetters';
import { GET_STAFFING_DASHBOARD_DATA } from '../../dashboard/graphql';
import OpportunityDashboardZone from './OpportunityDashboardZone';

type OpportunityDashboardFilters = {
  filter: {
    projectState?: { eq: string };
    name?: { ct: string };
  };
};

const StaffingDashboardContent: React.FC = () => {
  const { data } = useListContext();

  const projectsByStatus = useMemo((): StaffingRiskByPriority => {
    const projects = data?.items || [];
    const grouped: StaffingRiskByPriority = {
      SAFE: [],
      MONITORING: [],
      CRITICAL: [],
    };

    projects.forEach((project: StaffingDataType) => {
      const backendZone = project.staffingRisk?.priority || STAFFING_PRIORIRY_ZONES_ALIASES.SAFE;

      if (STAFFING_PRIORIRY_ZONES_ALIASES[backendZone]) {
        grouped[backendZone as keyof StaffingRiskByPriority].push(project);
      } else {
        grouped.SAFE.push(project);
      }
    });

    return grouped;
  }, [data?.items]);

  return (
    <ListPageLayout sxPaper={{ p: '10px!important' }}>
      <DashboardProvider dataGetters={staffingDataGetters}>
        {Object.entries(STAFFING_PRIORIRY_ZONES_ALIASES)
          .reverse()
          .map(([key, alias]) => {
            const zone = alias as HealthZone;
            const zoneKey = alias as HealthZone;
            return <OpportunityDashboardZone key={key} zone={zone} projects={projectsByStatus[zoneKey]} />;
          })}
      </DashboardProvider>
    </ListPageLayout>
  );
};

const OpportunityDashboard = () => {
  const transformVariables = (params: LoadingParams) => {
    let searchString = '';
    if (params.filter?.['specification:search']?.eq) {
      searchString = params.filter['specification:search'].eq;
    }

    const createSearchString = (searchTerm: string): string => {
      const filterObject: OpportunityDashboardFilters = {
        filter: {},
      };

      filterObject.filter.projectState = { eq: 'PRESTART' };

      if (searchTerm && searchTerm.trim()) {
        filterObject.filter.name = { ct: searchTerm.trim() };
      }

      return JSON.stringify(filterObject);
    };

    return {
      searchString: createSearchString(searchString),
    };
  };

  return (
    <GraphQLList query={GET_STAFFING_DASHBOARD_DATA} dataPath="baseProjects" transformVariables={transformVariables}>
      <StaffingDashboardContent />
    </GraphQLList>
  );
};

export default OpportunityDashboard;
